import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import {
    EFMicrowaveH5,
    EFWaterHeaterH5,
    EFLaptop,
    EFInductionCooker,
    EFLightH5,
    EFCrockpotH5,
    EFAirConditionerH5,
    EFTV,
    EFFridge,
    EFCustomH5,
    EFIconMoreH5,
} from '@/components/UI/svg/mm100';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/h5/');

export default function Comp({}: any) {
    const { useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const router = useRouter();
    const { locale } = router;

    const list2: any = {
        line1: [
            {
                title: t('presale.product.kitD_Microwave'),
                icon: <EFMicrowaveH5 width="0.48rem" height="0.48rem" />,
            },
            {
                title: t('presale.product.kitD_WaterHeater'),
                icon: <EFWaterHeaterH5 width="0.48rem" height="0.48rem" />,
            },
            {
                title: t('presale.product.kitD_Laptop'),
                icon: <EFLaptop width="0.48rem" height="0.48rem" />,
            },
        ],
        line2: [
            {
                title: t('presale.product.kitD_Light'),
                icon: <EFLightH5 width="0.48rem" height="0.48rem" />,
            },
            {
                title: t('presale.product.kitD_InductionCooker'),
                icon: <EFInductionCooker width="0.48rem" height="0.48rem" />,
            },
            {
                title: t('presale.product.kitD_Crockpot'),
                icon: <EFCrockpotH5 width="0.48rem" height="0.48rem" />,
            },
        ],
        line3: [
            {
                title: t('presale.product.kitD_TV'),
                icon: <EFTV width="0.48rem" height="0.48rem" />,
            },
            {
                title: t('presale.product.kitD_AirConditioner'),
                icon: <EFAirConditionerH5 width="0.48rem" height="0.48rem" />,
            },
            {
                title: t('presale.product.kitD_Fridge'),
                icon: <EFFridge width="0.48rem" height="0.48rem" />,
            },
        ],
        line4: [
            {
                title: t('presale.product.kitD_Custom'),
                icon: <EFCustomH5 width="0.48rem" height="0.48rem" />,
            },
        ],
    };

    return (
        <div className={`${css.kitD} kitD`}>
            <div className="kit-ms1">{t(locale === 'kr' ? 'presale.product.kitD_ms1_h5' : 'presale.product.kitD_ms1')}</div>
            <div className="kit-ms2" style={{ display: locale === 'us' ? 'block' : 'none' }}>
                <Link href={`/${locale}/calculators/power-kits`} newWin>
                    <div className="kit-ms2__box">
                        <span className="kit-ms2__Link">{t('presale.product.kitD_link1')}</span>
                        <div className="icon">
                            <EFIconMoreH5 width="0.12rem" height="0.12rem" />
                        </div>
                    </div>
                </Link>
            </div>
            <div className="kit-box1">
                <EFPic name={['KitD1.webp', 'KitD1.png']} className="fullImgs" alt="" />
                <div className="title-list">
                    <div className="title kWh2">{t('presale.product.2kWh')}</div>
                    <div className="title kWh4">{t('presale.product.4kWh')}</div>
                    <div className="title kWh5">{t('presale.product.5kWh')}</div>
                    <div className="title kWh10">{t('presale.product.10kWh')}</div>
                    <div className="title kWh15">{t('presale.product.15kWh')}</div>
                </div>
            </div>
            <div className="kit-box2">
                <div className="kit-ms-a1">{t(locale === 'kr' ? 'presale.product.kitD_ms_a1_h5' : 'presale.product.kitD_ms_a1')}</div>
                <div className="kit-ms-a2">{t(locale === 'kr' ? 'presale.product.kitD_ms_a2_h5' : 'presale.product.kitD_ms_a2')}</div>
                {Object.keys(list2)?.map((key: any, i: number) => (
                    <div className={`list-box2 ${key === 'line4' ? 'last-line' : ''}`} key={key}>
                        {list2[key].map((item: any, index: number) => (
                            <div className="icon-item" key={index}>
                                <div className="icon-box">{item.icon}</div>
                                <div className="icon-ms">{item.title}</div>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
